export default __webpack_public_path__ + "static/lets-talk01-c7256c946a6335d7d83003fd7590dc34.png";